/* eslint-disable max-len */

import {
  MEDIA_BROWSER_FETCH_LIST,
  MEDIA_BROWSER_FETCH_LIST_ERROR,
  MEDIA_BROWSER_FETCH_LIST_LOADING,
  MEDIA_BROWSER_FETCH_LIST_SUCCESS,
  MEDIA_BROWSER_FETCH_ITEM,
  MEDIA_BROWSER_FETCH_ITEM_ERROR,
  MEDIA_BROWSER_FETCH_ITEM_LOADING,
  MEDIA_BROWSER_FETCH_ITEM_SUCCESS,
} from './mediaBrowserConstants';

import Log from '../../utils/Debug';

const initialState = {
  allMedia: [],
  progress: 0,
  lastError: false,
  mediaId: '',
  currentMedia: {},
  loading: false,
};

// Action Creators ::
export const fetchMediaListAction = () => ({
  type: MEDIA_BROWSER_FETCH_LIST,
});

export const fetchMediaListErrorAction = error => ({
  error,
  type: MEDIA_BROWSER_FETCH_LIST_ERROR,
});

export const fetchMediaListLoadingAction = progress => ({
  progress,
  type: MEDIA_BROWSER_FETCH_LIST_LOADING,
});

export const fetchMediaListSuccessAction = allMedia => ({
  allMedia,
  type: MEDIA_BROWSER_FETCH_LIST_SUCCESS,
});

// ----------------- >>

export const fetchMediaItemAction = mediaId => ({
  mediaId,
  type: MEDIA_BROWSER_FETCH_ITEM,
});

export const fetchMediaItemErrorAction = error => ({
  error,
  type: MEDIA_BROWSER_FETCH_ITEM_ERROR,
});

export const fetchMediaItemLoadingAction = progress => ({
  progress,
  type: MEDIA_BROWSER_FETCH_ITEM_LOADING,
});

export const fetchMediaItemSuccessAction = (mediaId, bearerToken) => ({
  mediaId,
  bearerToken,
  type: MEDIA_BROWSER_FETCH_ITEM_SUCCESS,
});

export const clearLastErrorAction = () => ({
  error: null, type: MEDIA_BROWSER_FETCH_ITEM_ERROR,
});

const mediaBrowserReducer = (state = initialState, action) => {
  Log.info('---- mediaBrowserReducer ----', action);
  switch (action.type) {
    case MEDIA_BROWSER_FETCH_LIST:
      // Triggers the Saga Watcher
      return {
        ...state,
      };
    case MEDIA_BROWSER_FETCH_LIST_ERROR:
      return {
        ...state,
        loading: false,
        lastError: action.error,
        allMedia: [],
      };
    case MEDIA_BROWSER_FETCH_LIST_LOADING:
      return {
        ...state,
        loading: true,
        progress: action.progress,
        allMedia: action.allMedia,
      };
    case MEDIA_BROWSER_FETCH_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        allMedia: action.allMedia,
      };

    // ----------------- >>
    case MEDIA_BROWSER_FETCH_ITEM:
      return {
        ...state,
        mediaId: action.mediaId,
      };
    case MEDIA_BROWSER_FETCH_ITEM_ERROR:
      return {
        ...state,
        lastError: action.error,
        currentMedia: {},
      };
    case MEDIA_BROWSER_FETCH_ITEM_LOADING:
      return {
        ...state,
        progress: action.progress,
      };
    case MEDIA_BROWSER_FETCH_ITEM_SUCCESS:
      return {
        ...state,
        mediaId: action.mediaId,
        bearerToken: action.bearerToken,
      };
    default:
      return state;
  }
};

export default mediaBrowserReducer;
